$('#section-verification').on("submit", function (e) {
    e.preventDefault();

    //validate entire form
    if (!$(this).valid()) {
        return;
    }

    $(':submit', this).attr('disabled', 'disabled');
        
    $("*[id*=section-]:visible").hide();

    $("#section-loading").show();

    $.ajax({
        url: "/Application/VerifyID",
        type: "POST",
        data: $(this).serialize(),
        success: function (data) {
            $("button.gold").hide();
            $(".applybutton").show();

            switch (data.result) {
                case "NotVerified":
                    $("*[id*=section-]:visible").hide();
                    $("#section-verification").show();
                    return;
                case "VerifiedWithOffer":
                    $("*[id*=section-]:visible").hide();
                    $("#section-confirmation").show();
                    $("#successmessage").html("Great news, " + data.name + "! <br />You're on the list.");
                    return;
                case "VerifiedWithoutOffer":
                    window.location.replace("/Application/Offer-Not-Available");
                    return;
                default:
                    window.location.replace("/Application/Error?e=verify");
            }

            window.location = "/Application/Error?e=verify";
        },
        error: function (jqXHR, textStatus, errorThrown) {
            window.location = "/Application/Error?e=verify-" + encodeURIComponent(errorThrown);
        },
        timeout: 60000
    });
});